module.exports = "pegasus/assets/blocks/column-11-tech.png";